/* ****************************************************************************
Name:			  Create Report
**
** Desc:         Create Report
** Author:        VAsu Pabbaraju
** Date:          2020/08/01

*******************************************************************************
**       CHANGE HISTORY
*******************************************************************************
**  Date			    Author					 Description
**  ----------  -----------------------  --------------------------------------

******************************************************************************/
import React, { Fragment, useEffect, useState,useRef } from 'react';
import PageTitle from '../../Layout/AppMain/PageTitle';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { withRouter } from "react-router-dom";
import XLSX from 'xlsx';
import gql from 'graphql-tag';
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import SweetAlert from 'react-bootstrap-sweetalert';
import UploadCreate from './upolad_create_report'
import {
    Col, CardTitle, TabContent, TabPane, Nav, NavItem, NavLink,Input,FormText,
    Card, Modal, ModalHeader, ModalBody, ModalFooter, Row, Form, FormGroup, Label,
    CardBody, Button, InputGroupAddon, CardHeader, CardFooter, Breadcrumb, BreadcrumbItem
} from 'reactstrap';
import classnames from 'classnames';
import { Typeahead } from 'react-bootstrap-typeahead';


//Get List of Open PO for the vendor Config
const GET_OPEN_PO = gql`
      query getOpenPO($VendorNum: String, $OpenPOFlag:String){
        SupplierPO(filters: {
           VendorNum:$VendorNum
           OpenPOFlag: $OpenPOFlag
    }) {
     edges {
       node {
         PONum
         MaterialNum
         MaterialRev
         POQty 
         RcvdQty
       }
     }
    }
  }
`;

//Get Plan Details by Part Number and Revision
const GET_PLAN_DETAILS_PART = gql`
      query vwApp1factplanspecsbypartrev($PartNum: String, $PartRev: String){
        vwApp1factplanspecsbypartrev(filters: {
           PartNum:$PartNum,
           PartRev:$PartRev
    },sort:COL_SL_NUM_ASC) {
     edges {
       node {
         PlanID
         PartNum
         PartDesc
         PartRev
         SpecId
         Label
         LabelNum
         Method
         LSL
         USL
         SpecDataType
         Precision
         ColIndex
         ColSlNum
         Sampling
         AQL
         Characteristic
         SpecType
         SpecVal
         SpecValMin
         SpecValMax
         SpecValTOLPlus
         SpecValTOLMinus
         BonusTOL
         NumPlaces
         BaloonNum
         SheetNum
       }
     }
    }
  }
`;

//Create a new report mutation config
const CREATE_REPORT = gql`
    mutation SupplierFileHeader(
       $VendorNum: String
       $MasterLotNum: String
       $MasterLotQty: String
       $SubLotNum: String
       $SubLotQty: String
       $PartNum: String
       $AgileDocIDVer: String
       $Program: String
       $SupplierLogID: String
       $PONum: String
       $FileGUID: String
       $UpdateTS: String
       $factPlanID: Int
       $LoadTS: String
       $Status: String
       $sampleUnits: Int
       $timeOrder: Int
       $PackingSlipNum: String
       $PartialShipmentFlag: Int
       $DetailString: String
       $mstrLotCompletionDate: String
    ) {
      SupplierFileHeader(input:{
    VendorNum:$VendorNum
    MasterLotNum: $MasterLotNum
    MasterLotQty: $MasterLotQty
    SubLotNum: $SubLotNum
    SubLotQty: $SubLotQty
    PartNum:$PartNum
    Program: $Program
    AgileDocIDVer:$AgileDocIDVer
    SupplierLogID:$SupplierLogID
    PONum:$PONum
    FileGUID:$FileGUID
    UpdateTS:$UpdateTS
    LoadTS:$LoadTS
    Status: $Status
    sampleUnits: $sampleUnits
    timeOrder: $timeOrder
    PackingSlipNum: $PackingSlipNum
    PartialShipmentFlag: $PartialShipmentFlag
    DetailString:$DetailString
    factPlanID:$factPlanID
    mstrLotCompletionDate: $mstrLotCompletionDate
  }){
    iHeader {
      FileGUID
      Status
      MeasureLotFlag
    }
  }
}`;



const CreateReport = ({ history }) => {

    const [POMaterial, setPOMaterial] = useState([]);
    const [MaterialRev, setMaterialRev] = useState([]);
    const [PartNum, setPartNum] = useState(null);
    const [AgileDocIDVer, setAgileDocIDVer] = useState(null);
    const [sampleUnits, setSampleUnits] = useState(null);
    const [planDetails, setPlanDetails] = useState(null);
    const [showValidatePlan, setShowValidatePlan] = useState(false);
    const [planError, setPlanError] = useState(false);
    const [showLoading, setShowLoading] = useState(null);
    const [timeOrdered, setTimeOrdered] = useState(false);
    const [reportMode, setReportMode] = useState('CreateReport')
    const [showPlanDoesNotExist, setShowPlanDoesNotExist] = useState(false);
    const [subgroupSize, setSubGroupSize] = useState(null);
    const [subgroupsizeText, setSubgroupsizeText] = useState(null);
    const [subgroupSizeValidated, setSubGroupSizeValidated] = useState(false);
    const revRef = useRef();
    const [step, setStep] = useState(1);
    const [SupplierFileHeader] = useMutation(CREATE_REPORT);

    const { data } = useQuery(GET_OPEN_PO, {
        fetchPolicy: 'no-cache',
        variables: { VendorNum: localStorage.getItem('loggedInVendor'), 'OpenPOFlag': '1' }
    });

     //Get Plan details call
   const [getPlanDetailsByPartData] = useLazyQuery(GET_PLAN_DETAILS_PART, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      if (data.vwApp1factplanspecsbypartrev.edges.length > 0) {
        setPlanDetails(data.vwApp1factplanspecsbypartrev.edges);
        setShowLoading(false);
        setShowValidatePlan(false);
        setShowPlanDoesNotExist(false);
        setShowValidatePlan(true);
      } else {
        setShowLoading(false);
        setShowPlanDoesNotExist(true);
        setShowValidatePlan(false);
        // document.getElementById('NewReportBtn').style.display = 'none';
      }
    }
  });


    //Event to get PO Details
    useEffect(() => {

        if (data) {
            let t_openPO = [];
            let t_material = [];
            data.SupplierPO.edges.map((el) => {
                const checkPO = t_openPO.filter(po => po.PONum == el.node.PONum);
                const checkMaterial = t_material.filter(material => material.MaterialNum == el.node.MaterialNum);
                if (checkPO.length == 0) {
                    t_openPO.push({ PONum: el.node.PONum });
                }

                if (checkMaterial.length == 0) {
                    t_material.push({ MaterialNum: el.node.MaterialNum });
                }
            });
            t_openPO = t_openPO.sort((a, b) => parseFloat(a.PONum) - parseFloat(b.PONum));


            t_material = t_material.sort((a, b) => parseFloat(a.MaterialNum) - parseFloat(b.MaterialNum));
            setPOMaterial(t_material);
        }
    }, [data]);

    const navigateHome = () => {
        history.push('/cha/landingpage');
    }

    const onChangeMaterial = (MaterialNum) => {
        let t_material_rev = [];
        let t_openPO = [];
        setMaterialRev([]) ;
        setShowPlanDoesNotExist(false);
        setShowValidatePlan(false);
        setTimeout(() =>  revRef.current.clear(), 0);
        if (MaterialNum.length > 0) {
            setPartNum(MaterialNum[0].MaterialNum);
            data.SupplierPO.edges.map((el) => {
                if (el.node.MaterialNum == MaterialNum[0].MaterialNum) {
                    const checkRev = t_material_rev.filter(rev => (el.node.MaterialRev == rev.MaterialRev));
                    if (checkRev.length == 0) {
                        t_material_rev.push({ MaterialRev: el.node.MaterialRev });
                    }
                }
            });
            setMaterialRev(t_material_rev);
        }
    }

    const MaterialRevChange = (MaterialRev) => {
        if (MaterialRev.length > 0) {
            setShowLoading(true);
            setAgileDocIDVer(MaterialRev[0].MaterialRev);
            setShowValidatePlan(true);
            validatePlan(MaterialRev[0].MaterialRev);
          } else {
            setAgileDocIDVer(null);
          }
    }


  const validatePlan = (docVer) => {
    getPlanDetailsByPartData({
      variables: {
        PartNum: PartNum,
        PartRev: docVer
      }
    });
  }

    const changeSampleUnits = (e) => {
        if (parseInt(e.target.value.replace(/[^\x00-\x7F]/g, ""))) {
            setSampleUnits(e.target.value.replace(/[^\x00-\x7F]/g, "")); 
          }
      }

      const CreateReport = () => {
        if (planDetails && planDetails.length > 0) {
            setShowLoading(true);
            let headerObject = {};
            headerObject['PartNum'] = PartNum;
            headerObject['AgileDocIDVer'] = AgileDocIDVer;
            headerObject['PONum'] = "";
           
            if (planDetails) {
              headerObject['partDesc'] = planDetails[0].node.PartDesc;
            }
            headerObject['sampleUnits'] = sampleUnits;
            // setHeader(headerObject);
            // if (!fileGuid) {
            //   const tPlanDetails = planDetails;
            //   let tdetails = [];
            //   insertData(headerObject, tdetails, tPlanDetails);
            // }
          } else {
            setPlanError(true);
          }
      }

      //Create a new report function
  const insertData = async (headerObject, detailObject, planDetails) => {
  
  };

  const setStepProcess = () => {
    setStep(step + 1);
  }

  const setStepBackProcess = () => {
    setStep(step - 1);
  }

  const changeTimeOrdered = (timeorder) => {
    setTimeOrdered(timeorder);
    if (!timeorder) {
      setSubGroupSize('');
      document.getElementById('timeorderno').checked = true;
      document.getElementById('timeorderyes').checked = false;
    }


  }

  const changeSubgroupSize = (value) => {
    if (sampleUnits && value != '') {
      if (sampleUnits % value == 0) {
        setSubGroupSize(value);
        setSubgroupsizeText('');
        setSubGroupSizeValidated(true);

      } else {
        setSubgroupsizeText('Sample size must be multiples of ' + value);
        setSubGroupSize(value);
        setSubGroupSizeValidated(false);;

        // alert('Sample size must be multiples of ' + value);
        return true;
      }
    } else {
      setSubgroupsizeText('Please enter sample size');
      setSubGroupSize(value);
      setSubGroupSizeValidated(false);
      // alert('Please enter sample size');
      return true;
    }
  }

    return (

        <Fragment>
            <ReactCSSTransitionGroup
                component="div"
                transitionName="TabsAnimation"
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={false}>
                <div >
                    <Breadcrumb>
                        <BreadcrumbItem style={{ paddingTop: '0.5rem' }}><a href="javascript:void(0);" onClick={navigateHome}>Home</a> </BreadcrumbItem>
                        <BreadcrumbItem style={{ paddingTop: '0.5rem' }} active>Create New Report</BreadcrumbItem>

                    </Breadcrumb>
                    <PageTitle
                        heading="Create New Report"
                        icon="pe-7s-keypad icon-gradient bg-mean-fruit"
                    />
                    <div class="container">

                        <Card>
                            <CardHeader>Report Information</CardHeader>


                            <CardBody>
                                <Form>
                                  {(step == 1)?
                                  <>
                                    <div class="row">
                                            <div class="col">
                                                <div>
                                                    <label class="radio-inline" >Please select creation Mode</label>                                                </div>
                                            </div>
                                        </div>
                                    <div class="row">
                                            <div class="col">
                                                <div>
                                                    <label class="radio-inline" style={{ marginLeft: '20px' }}> <input onClick={() => {setReportMode('CreateReport') }} style={{ marginLeft: '-20px', position: 'absolute' }} type="radio" name="reportmode" id='CreateReportMode' checked={(reportMode == 'CreateReport') ? true : false} />Create Report</label>                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <div>
                                                    <label class="radio-inline" style={{ marginLeft: '20px' }}><input onClick={() => { setReportMode('UploadFile')}} style={{ marginLeft: '-20px', position: 'absolute' }} type="radio" name="reportmode" id='UploadFileMode' checked={(reportMode == 'UploadFile') ? true : false} />Upload File</label>
                                                </div>
                                            </div>
                                        </div>
                                        </>
                                        : null}
                                {(step == 2)?
                                  <>
                                    {(reportMode == 'CreateReport')?
                                    <FormGroup row>

                                        <Col sm={2}>
                                            <Label className="control-label required" for="PartNum">Material Number</Label>

                                            <Typeahead
                                                id="PartNum"
                                                labelKey="MaterialNum"
                                                valueKey="MaterialNum"
                                                onChange={onChangeMaterial}
                                                options={POMaterial}
                                                placeholder="Please select Material..."

                                            />
                                        </Col>
                                        <Col sm={2}>
                                            <Label className="control-label required" for="AgileDocIDVer">Agile Doc ID / Rev</Label>
                                            <Typeahead
                                            ref={revRef}
                                                id="AgileDocIDVer"
                                                disabled={(!PartNum)? true: false}
                                                labelKey="MaterialRev"
                                                valueKey="MaterialRev"
                                                onChange={MaterialRevChange}
                                                options={MaterialRev}
                                                placeholder="Please select Material..."

                                            />
                                        </Col>
                                        <Col sm={2}>
                                            <Label className="control-label required" for="exampleEmail">Sample Units</Label>
                                            <Input disabled={(!showValidatePlan)? true: false} autocomplete="off" id='sampleUnits' type="number"  value={sampleUnits} onChange={(e) => changeSampleUnits(e)} />
                                            <FormText></FormText>
                                        </Col>

                                        <Col sm={2}>
                                        <Label className="control-label required" for="exampleEmail">Time Ordered?</Label>
                                        <div>
                                          <label class="radio-inline" style={{ marginLeft: '20px' }}><input  onClick={() => changeTimeOrdered(true)} style={{ marginLeft: '-20px', position: 'absolute' }} type="radio" name="timeorder" id='timeorderyes' checked={(timeOrdered) ? true : false} />Yes</label>
                                          <label class="radio-inline" style={{ marginLeft: '30px' }}><input  onClick={() => changeTimeOrdered(false)} style={{ marginLeft: '-20px', position: 'absolute' }} type="radio" name="timeorder" id='timeorderno' checked={(!timeOrdered) ? true : false} />No</label>
                                          <FormText>
                                            <ul><li><u>Time ordered data:</u> Sampled parts measurements that have production time information</li>
                                              <li><u>Not in a time order:</u> Sampled parts measurements that do not have production time information</li></ul>
                                          </FormText>

                                        </div>
                                      </Col>
                                      {(timeOrdered) ?
                                        <Col sm={2}>
                                          <Label className="control-label required" for="exampleEmail">Sub Group Size?</Label>
                                          <div>
                                            <Input autocomplete="off" id='subgroupSize' type="number" disabled={(reportMode == 'Draft' || reportMode == 'Submitted' || reportMode == 'Processed' || !sampleUnits) ? true : false} value={subgroupSize} onChange={e => { changeSubgroupSize(e.target.value.replace(/[^\x00-\x7F]/g, "")); }} />
                                            <FormText style={{ color: 'red' }}>{subgroupsizeText}</FormText>
                                          </div>
                                        </Col>
                                        : null}
                       

                                        
                                    </FormGroup>
                                    :null}
                                    </>
                              : null}
                                </Form>
                               
                            </CardBody>
                            <CardFooter>
                                {(showPlanDoesNotExist) ? <div style={{ textAlign: 'center', color: 'red', fontWeight: 'bold' }}> There is no inspection plan available for the selected Part Number and Revision</div> : null}
                                <Button   onClick={() => setStepBackProcess()} style={{marginRight:'auto', display: (step>1)?'inline': 'none'}}>Back</Button>
                                <Button   onClick={() => setStepProcess()} style={{marginLeft:'auto'}}>Next</Button>

                            </CardFooter>

                        </Card>
                    </div>
                </div>

                {showLoading ?
                    <div style={{ width: '100%', textAlign: "center", marginTop: '20px', verticalAlign: 'center' }}>
                    <div class="spinner-border m-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div style={{ width: '100%', textAlign: "center", marginTop: '20px', fontSize: '20px' }}> Updating ..... </div>
            </div> : null}

            </ReactCSSTransitionGroup>
        </Fragment>
    )

}


export default (withRouter(CreateReport))
